export default function Logo() {
  return (
    <p>
      <span>🍿</span> Rate Movies
    </p>
  );
}
